import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RoleplayApiService } from '../../../../service/roleplay.service';
import { DatePipe } from '@angular/common';

export interface ConversationsDialogData {
    sessionId: number;
    feedbackDetail: any;
}

interface ChatMessage {
    question: string;
    answer: string;
    time: string;
    coach_used?: boolean;
    bot_last_response?: string;
}

@Component({
    selector: 'app-roleplay-feedback-conversations-dialog',
    templateUrl: './roleplay-feedback-conversations-dialog.component.html',
    styleUrls: ['./roleplay-feedback-conversations-dialog.component.scss'],
    standalone: false
})
export class RoleplayFeedbackConversationsDialogComponent implements OnInit {
    conversations: ChatMessage[] = [];
    history: any = null;
    isLoading: boolean = true;
    givenName = sessionStorage.getItem('givenName') || 'User';

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: ConversationsDialogData,
        private dialogRef: MatDialogRef<RoleplayFeedbackConversationsDialogComponent>,
        private rolePlayService: RoleplayApiService,
        private datePipe: DatePipe
    ) { }

    ngOnInit(): void {
        this.rolePlayService.chatRoleplayHistoryList(this.data.sessionId).subscribe({
            next: (data) => {
                this.history = data;
                this.givenName = data?.first_name || data?.given_by_first_name || sessionStorage.getItem('givenName') || 'User';
                this.mapConversations(data.conversations || []);
                this.isLoading = false;
            },
            error: () => {
                this.isLoading = false;
            }
        });
    }

    private mapConversations(response: any[]): void {
        this.conversations = response.map((msg: any) => {
            const localTime = this.convertUtcToLocal(msg.request_time);
            return {
                question: msg.user_request || '',
                answer: msg.bot_response || '',
                time: this.datePipe.transform(localTime, 'hh:mm MMM dd') || '',
                coach_used: msg.coach_used || false,
                bot_last_response: msg.bot_last_response || ''
            };
        });
    }

    private convertUtcToLocal(utcDateString: string): Date | null {
        if (!utcDateString) return null;
        return new Date(utcDateString.split('.')[0] + 'Z');
    }

    closeDialog(): void {
        this.dialogRef.close();
    }
}
